import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { CommitmentsUtilizationGrouping } from "@/services/cloudchipr.api";
import { commitmentUtilizationSetupPropertyByKeySelector } from "@/store/dashboards/selectors/setups/commitment-utilization/commitmentUtilizationSetupPropertyByKeySelector";
import { commitmentUtilizationWidgetSetupDataChangeThunk } from "@/store/dashboards/thunks/widgets/commitment-utilization/setup-change/commitmentUtilizationWidgetSetupDataChangeThunk";
import { CommitmentUtilizationWidgetGroupBySelect } from "@/components/pages/dashboard/components/widgets/commitment-utlization/components/CommitmentUtilizationWidgetGroupBySelect";

export const CommitmentUtilizationWidgetSetupGroupBySelect = () => {
  const dispatch = useAppDispatch();

  const grouping: CommitmentsUtilizationGrouping = useAppSelector(
    commitmentUtilizationSetupPropertyByKeySelector("grouping"),
  );

  const handleChange = useCallback(
    (grouping: CommitmentsUtilizationGrouping) => {
      dispatch(
        commitmentUtilizationWidgetSetupDataChangeThunk({
          grouping,
        }),
      );
    },
    [dispatch],
  );

  return (
    <CommitmentUtilizationWidgetGroupBySelect
      grouping={grouping}
      onChange={handleChange}
    />
  );
};
